<template>
  <el-dialog :title="title" :visible.sync="dialogFormVisible" style="z-index: 99" top="5vh" width="45vw"
    @close="handleClose">
    <audio ref="audioPlayer" src="@/assets/audio.mp3" controls style="display: none" />
    <audio ref="successAudioPlayer" src="@/assets/success.mp3" controls style="display: none" />
    <el-form ref="form" :model="form" label-width="auto" @submit.native.prevent>
      <!-- 包裹单号输入 -->
      <el-form-item label="包裹单号" class="scan-form-item">
        <el-input ref="codeInput" v-model.trim="form.old_kr_code" autocomplete="off" clearable
          placeholder="请扫描或输入包裹单号，按回车确认" class="scan-input" @keyup.enter.native="handleQuery"
          @keyup.space.native="handleSpaceInInput" />
      </el-form-item>

      <!-- 已扫描包裹列表（合箱场景） -->
      <el-form-item v-if="shippingType === 4 || shippingType === 7" label="已扫描包裹">
        <div v-for="(item, index) in scannedPackages" :key="index" class="package-tag">
          {{ item }}
        </div>
        <span v-if="scannedPackages.length === 0" style="color: #999">暂无扫描记录</span>
      </el-form-item>

      <!-- 全部包裹列表（合箱场景）- 已扫描的显示绿色背景 -->
      <el-form-item v-if="shippingType === 4 || shippingType === 7" label="全部包裹">
        <div v-for="(item, index) in allPackageList" :key="index" class="package-tag"
          :class="{ 'package-tag-scanned': isPackageScanned(item) }">
          {{ item }}
          <span v-if="isPackageScanned(item)" class="check-mark">✓</span>
        </div>
        <span v-if="allPackageList.length === 0" style="color: #999">暂无数据</span>
      </el-form-item>
    </el-form>

    <!-- 表格 -->
    <el-table :data="gridData" @selection-change="handleSelectionChange" style="width: 100%;font-size: 18px;">
      <!-- 多选列（分箱/合箱后分箱场景） -->
      <el-table-column v-if="shippingType === 3 || shippingType === 7" type="selection" width="40" align="center" />

      <!-- 包裹单号 -->
      <el-table-column prop="old_kr_code" align="center" label="包裹单号" />

      <!-- 部分出库开关（合箱场景） -->
      <!-- <el-table-column v-if="shippingType === 4" label="部分出库" width="100" align="center">
        <template #default="{ row }">
          <el-switch
            v-model="row.store_status"
            :active-value="2"
            :inactive-value="1"
          />
        </template>
</el-table-column> -->

      <!-- 备注 -->
      <!-- <el-table-column label="备注" prop="remark" min-width="200">
        <template #default="{ row }">
          <el-input
            v-model="row.remark"
            size="small"
            placeholder="请输入备注"
            clearable
          />
        </template>
      </el-table-column> -->

      <!-- 操作 -->
      <el-table-column label="操作" align="center" fixed="right">
        <template #default="{ $index }">
          <el-button type="text" style="color: #f56c6c" size="small" @click="handleDeleteRow($index)">
            移除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 底部按钮 -->
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" :loading="printLoading" @click="handlePrintSheet">
        打印面单
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  OrderQuickDetail,
  orderNotice,
  combinedBoxCheck,
  orderOutbound,
} from '@/api/xgcApi'

export default {
  name: 'ScanDialog',

  props: {
    korType: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      // 弹窗相关
      title: '扫描单号',
      dialogFormVisible: false,

      // 表单数据
      form: {
        old_kr_code: '',
      },

      // 表格数据
      gridData: [],

      // 选中的行（分箱场景）
      selectedRows: [],

      // 发货方式：1-原箱 2-原箱套箱 3-分箱 4-合箱 6-换箱 7-合箱后分箱
      shippingType: null,

      // 合箱场景数据
      scannedPackages: [], // 已扫描的包裹列表
      allPackageList: [], // 全部包裹列表
      combinedOrderId: '', // 合箱订单ID
      tempCode: '', // 合箱后拆箱临时code
      isCombinedOrderConfirmed: false, // 合箱订单是否已确认

      // 加载状态
      printLoading: false,

      // 防止重复提交
      isProcessing: false,

      // 音频播放防抖
      audioPlaying: false,
    }
  },

  mounted() {
    // 监听全局空格键（用于快捷打印）
    document.addEventListener('keydown', this.handleGlobalSpace)
  },

  beforeDestroy() {
    document.removeEventListener('keydown', this.handleGlobalSpace)
  },

  methods: {
    // ==================== 音频相关 ====================

    /**
     * 播放成功声音
     */
    playSuccessAudio() {
      if (this.audioPlaying) return
      this.audioPlaying = true
      try {
        const audio = this.$refs.successAudioPlayer
        if (audio) {
          audio.currentTime = 0
          audio.play().catch(() => { })
          setTimeout(() => {
            this.audioPlaying = false
          }, 500)
        } else {
          this.audioPlaying = false
        }
      } catch (error) {
        this.audioPlaying = false
      }
    },

    /**
     * 播放异常声音
     */
    playAudio() {
      if (this.audioPlaying) return
      this.audioPlaying = true
      try {
        const audio = this.$refs.audioPlayer
        if (audio) {
          audio.currentTime = 0
          audio.play().catch(() => { })
          setTimeout(() => {
            this.audioPlaying = false
          }, 500)
        } else {
          this.audioPlaying = false
        }
      } catch (error) {
        this.audioPlaying = false
      }
    },

    /**
     * 获取发货类型的中文名称
     */
    getShippingTypeLabel(type) {
      const typeMap = {
        1: '原箱发货',
        3: '分箱发货',
        4: '合箱发货',
        6: '原箱发货',
        7: '合箱后分箱',
      }
      return typeMap[type] || `未知类型(${type})`
    },

    // ==================== 弹窗控制 ====================

    /**
     * 显示弹窗（由父组件调用）
     */
    showEdit(row) {
      this.resetAllData()
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.focusInput()
      })
    },

    /**
     * 关闭弹窗
     */
    handleClose() {
      this.dialogFormVisible = false
      this.resetAllData()
    },

    /**
     * 重置所有数据
     */
    resetAllData() {
      // 重置表单
      this.form = {
        old_kr_code: '',
      }

      // 重置表格数据
      this.gridData = []
      this.selectedRows = []

      // 重置合箱数据
      this.scannedPackages = []
      this.allPackageList = []
      this.combinedOrderId = ''
      this.tempCode = ''
      this.isCombinedOrderConfirmed = false

      // 重置状态
      this.shippingType = null
      this.isProcessing = false
      this.printLoading = false
      this.audioPlaying = false

      // 重置表单验证状态
      if (this.$refs.form) {
        this.$refs.form.resetFields()
      }
    },

    /**
     * 聚焦到输入框
     */
    focusInput() {
      if (this.$refs.codeInput) {
        this.$refs.codeInput.focus()
      }
    },

    // ==================== 辅助方法 ====================

    /**
     * 判断包裹是否已扫描
     */
    isPackageScanned(packageCode) {
      return this.scannedPackages.includes(packageCode)
    },

    // ==================== 键盘事件 ====================

    /**
     * 全局空格键监听（快捷打印）
     * 仅在弹窗打开且焦点不在输入框时触发
     */
    handleGlobalSpace(event) {
      if (event.keyCode === 32 && this.dialogFormVisible) {
        // 如果焦点在输入框，不触发打印（由 handleSpaceInInput 处理）
        const target = event.target
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA') {
          return
        }
        event.preventDefault()
        this.handlePrintSheet()
      }
    },

    /**
     * 输入框中按空格键（仅阻止默认行为，不触发打印）
     */
    handleSpaceInInput(event) {
      event.stopPropagation()
    },

    // ==================== 扫码逻辑 ====================

    /**
     * 处理回车键（确认扫描）
     */
    handleQuery() {
      const code = this.form.old_kr_code
      if (!code) {
        this.$baseMessage('请输入或扫描包裹单号', 'warning')
        return
      }

      // 防止重复提交
      if (this.isProcessing) {
        return
      }

      this.isProcessing = true
      this.getParcelDetail()
    },

    /**
     * 查询包裹详情
     */
    async getParcelDetail() {
      try {
        const code = this.form.old_kr_code
        const res = await OrderQuickDetail({ old_kr_code: code })

        const data = res.data
        const newShippingType = data.shipping_type

        // ✅ 如果已经确认了合箱订单，但扫描的包裹类型不是合箱，直接报错，保留已扫描记录
        if (this.isCombinedOrderConfirmed && newShippingType !== 4) {
          this.$baseMessage(
            `扫描失败：当前正在扫描合箱订单，不能扫描其他类型的包裹（当前类型：${this.getShippingTypeLabel(newShippingType)}），已扫描 ${this.scannedPackages.length}/${this.allPackageList.length}`,
            'error'
          )
          this.playAudio()
          this.form.old_kr_code = ''
          this.isProcessing = false
          this.focusInput()
          return
        }

        // ✅ 如果切换了发货类型，清空之前的数据
        if (this.shippingType !== null && this.shippingType !== newShippingType) {
          // 清空表格数据
          this.gridData = []
          this.selectedRows = []
          // 清空合箱相关数据
          this.scannedPackages = []
          this.allPackageList = []
          this.combinedOrderId = ''
          this.tempCode = ''
          this.isCombinedOrderConfirmed = false
        }

        this.shippingType = newShippingType

        // 根据发货类型处理
        switch (this.shippingType) {
          case 1:
          case 2:
          case 6:
            await this.handleOriginalBox(data)
            break
          case 3:
            await this.handleSplitBox(data)
            break
          case 4:
            await this.handleCombinedBox(data)
            break
          case 7:
            await this.handleCombinedThenSplit(data)
            break
          default:
            this.$baseMessage(`未知的发货类型: ${this.shippingType}`, 'error')
            this.shippingType = null
        }
        this.form.old_kr_code = ''
        this.focusInput()
        this.isProcessing = false
      } catch (error) {
        console.error('查询包裹失败:', error)
        this.playAudio()
        this.form.old_kr_code = ''
        this.isProcessing = false
        this.focusInput()
      }
    },

    // ==================== 各发货类型处理 ====================

    /**
     * 处理原箱发货 (shippingType: 1, 6)
     * 原箱：扫描后直接拉单+出库
     */
    async handleOriginalBox(data) {
      this.playSuccessAudio()
      // 原箱发货直接拉单+出库
      const orderIds = [data.id]
      await this.pullAndOutbound(orderIds, {
        code: this.form.old_kr_code,
        type: 1, // 全部出库
      })
    },

    /**
     * 处理分箱发货 (shippingType: 3)
     * 分箱：展示分箱列表，用户选择后点击打印按钮批量出库
     */
    async handleSplitBox(data) {
      this.playSuccessAudio()
      // 展示分箱列表
      this.gridData = data.fen.map(item => ({
        ...item,
        remark: item.remark || '',
      }))

      // 保存当前扫描的code，用于后续出库
      this.tempCode = this.form.old_kr_code

      this.$baseMessage(`分箱数据已加载，请选择要出库的包裹`, 'success')
    },

    /**
     * 处理合箱发货 (shippingType: 4)
     * 合箱：逐个扫描包裹，全部扫描完成后自动打印出库
     * 如果有其他不属于这个合包的包裹扫描，提示不通过，但保留已扫描记录
     * 如果扫描到其他类型的包裹（非合箱），也提示错误并阻止，但保留已扫描记录
     */
    async handleCombinedBox(data) {
      const currentCode = this.form.old_kr_code

      // ============ 如果已经确认了合箱订单 ============
      if (this.isCombinedOrderConfirmed) {
        // 检查当前扫描的包裹是否属于当前合箱订单
        if (!this.allPackageList.includes(currentCode)) {
          this.$baseMessage(
            `扫描失败：包裹 "${currentCode}" 不属于当前合箱订单，请完成当前订单的扫描（已扫描 ${this.scannedPackages.length}/${this.allPackageList.length}）`,
            'error'
          )
          this.playAudio()
          // ✅ 只清空输入框，保留已扫描记录
          this.form.old_kr_code = ''
          this.isProcessing = false
          this.focusInput()
          return
        }

        // 检查是否已扫描过
        if (this.scannedPackages.includes(currentCode)) {
          this.$baseMessage('该包裹已扫描，请勿重复扫描', 'warning')
          this.isProcessing = false
          this.form.old_kr_code = ''
          this.focusInput()
          this.playAudio()
          return
        }

        // 添加到已扫描列表
        this.scannedPackages.push(currentCode)

        // 添加到表格
        this.gridData.push({
          old_kr_code: currentCode,
          remark: '',
          store_status: 1,
        })

        this.playSuccessAudio()
        this.$baseMessage(`扫描成功 (${this.scannedPackages.length}/${this.allPackageList.length})`, 'success')

        // 如果所有包裹都已扫描，自动拉单+出库
        if (this.scannedPackages.length === this.allPackageList.length) {
          this.$baseMessage('所有包裹已扫描完成，自动出库', 'success')
          setTimeout(() => {
            this.handleCombinedOutbound()
          }, 500)
        }
        return
      }

      // ============ 首次扫描合箱订单 ============
      // 检查当前扫描的包裹是否在合箱列表中
      if (!data.old_kr_code || !data.old_kr_code.split(',').filter(Boolean).includes(currentCode)) {
        this.$baseMessage(
          `扫描失败：包裹 "${currentCode}" 不属于该合箱订单，请扫描正确的包裹`,
          'error'
        )
        this.playAudio()
        // ✅ 首次扫描失败，重置状态（因为还没建立合箱订单）
        this.shippingType = null
        this.form.old_kr_code = ''
        this.isProcessing = false
        this.focusInput()
        return
      }

      // 保存合箱订单信息
      this.combinedOrderId = data.id
      this.allPackageList = data.old_kr_code.split(',').filter(Boolean)
      this.isCombinedOrderConfirmed = true

      // 添加到已扫描列表
      this.scannedPackages.push(currentCode)

      // 添加到表格
      this.gridData.push({
        old_kr_code: currentCode,
        remark: '',
        store_status: 1,
      })

      this.playSuccessAudio()
      this.$baseMessage(`扫描成功 (${this.scannedPackages.length}/${this.allPackageList.length})`, 'success')

      // 如果所有包裹都已扫描，自动拉单+出库
      if (this.scannedPackages.length === this.allPackageList.length) {
        this.$baseMessage('所有包裹已扫描完成，自动出库', 'success')
        setTimeout(() => {
          this.handleCombinedOutbound()
        }, 500)
      }
    },

    /**
     * 处理合箱后分箱 (shippingType: 7)
     */
    async handleCombinedThenSplit(data) {
      // 保存临时code
      this.tempCode = data.code

      // 获取全部包裹列表
      if (data.old_kr_code) {
        this.allPackageList = data.old_kr_code.split(',').filter(Boolean)
      }

      // 展示分箱数据
      if (data.fen && data.fen.length > 0) {
        this.gridData = data.fen.map(item => ({
          ...item,
          remark: item.remark || '',
        }))
        this.$baseMessage(`分箱数据已加载，请选择要出库的包裹`, 'success')
      } else {
        // 如果没有分箱数据，将当前扫描的包裹添加到列表
        const currentCode = this.form.old_kr_code
        if (!this.scannedPackages.includes(currentCode)) {
          this.scannedPackages.push(currentCode)
          this.gridData.push({
            old_kr_code: currentCode,
            remark: '',
          })
        }
      }
    },

    // ==================== 核心：拉单+出库 ====================

    /**
     * 拉单 + 出库（统一入口）
     * @param {Array} orderIds - 订单ID列表
     * @param {Object} outboundParams - 出库参数
     */
    async pullAndOutbound(orderIds, outboundParams) {
      if (!orderIds || orderIds.length === 0) {
        this.$baseMessage('没有可出库的订单', 'warning')
        return
      }

      try {
        this.printLoading = true

        // 1. 调用拉单接口
        const noticeData = {
          id: orderIds,
          type: 4,
        }
        const noticeRes = await orderNotice(noticeData)

        if (noticeRes.code !== 200) {
          this.$baseMessage(noticeRes.msg || '拉单失败', 'error')
          this.printLoading = false
          return
        }

        // 2. 调用出库接口
        const outRes = await orderOutbound(outboundParams)

        if (outRes.code === 200) {
          this.$baseMessage('出库成功', 'success')
          this.$emit('change', orderIds)

          // 清空数据并关闭弹窗
          this.resetAllData()
          this.dialogFormVisible = false
        } else {
          this.$baseMessage(outRes.msg || '出库失败', 'error')
        }

        this.printLoading = false
      } catch (error) {
        console.error('拉单出库失败:', error)
        this.$baseMessage('操作失败，请重试', 'error')
        this.printLoading = false
      }
    },

    // ==================== 分箱场景出库 ====================

    /**
     * 分箱/合箱后分箱 出库
     */
    async handleSplitOutbound() {
      if (this.selectedRows.length === 0) {
        this.$baseMessage('请选择要出库的包裹（勾选表格左侧复选框）', 'warning')
        return
      }

      // 提取选中的ID
      const selectedIds = this.selectedRows.map(item => item.id)

      // 构建备注数据
      const remarkMap = {}
      this.gridData.forEach(item => {
        if (item.remark) {
          remarkMap[item.id] = item.remark
        }
      })

      // 构建出库参数
      const outboundParams = {
        id: selectedIds,
        code: this.tempCode || this.form.old_kr_code,
        type: selectedIds.length === this.gridData.length ? 1 : 2,
        shipping_type: this.shippingType,
        id_data: remarkMap,
      }

      // 调用拉单+出库
      await this.pullAndOutbound(selectedIds, outboundParams)
    },

    // ==================== 合箱场景出库 ====================

    /**
     * 合箱发货出库
     */
    async handleCombinedOutbound() {
      if (this.gridData.length === 0) {
        this.$baseMessage('没有可出库的包裹', 'warning')
        return
      }

      try {
        this.printLoading = true

        const codeList = this.gridData.map(item => item.old_kr_code)

        // 1. 合箱校验
        const checkRes = await combinedBoxCheck({
          order_id: this.combinedOrderId,
          old_kr_code: codeList.join(','),
          type: 4,
        })

        if (checkRes.code !== 200) {
          this.$baseMessage(checkRes.msg || '合箱校验失败', 'error')
          this.printLoading = false
          return
        }

        // 2. 拉单
        const noticeData = {
          id: [this.combinedOrderId],
          type: 4,
        }
        const noticeRes = await orderNotice(noticeData)

        if (noticeRes.code !== 200) {
          this.$baseMessage(noticeRes.msg || '拉单失败', 'error')
          this.printLoading = false
          return
        }

        // 3. 逐个出库
        const outboundPromises = this.gridData.map(item => {
          return orderOutbound({
            code: item.old_kr_code,
            type: item.store_status || 1,
            remark: item.remark || '',
          })
        })

        const results = await Promise.all(outboundPromises)

        // 检查是否全部成功
        const hasError = results.some(res => res.code !== 200)
        if (hasError) {
          this.$baseMessage('部分包裹出库失败，请检查', 'error')
          this.printLoading = false
          return
        }

        this.$baseMessage('全部出库成功', 'success')
        this.$emit('change', [this.combinedOrderId])

        // 清空数据并关闭弹窗
        this.resetAllData()
        this.dialogFormVisible = false
        this.printLoading = false
      } catch (error) {
        console.error('合箱出库失败:', error)
        this.$baseMessage('出库失败，请重试', 'error')
        this.printLoading = false
      }
    },

    // ==================== 打印面单（统一入口） ====================

    /**
     * 打印面单（实际是出库操作）
     */
    async handlePrintSheet() {
      // 防重复点击
      if (this.printLoading || this.isProcessing) {
        return
      }

      // 验证数据
      if (this.gridData.length === 0) {
        this.$baseMessage('请先扫描包裹', 'warning')
        return
      }

      // 分箱/合箱后分箱 - 需要选择
      if (this.shippingType === 3 || this.shippingType === 7) {
        await this.handleSplitOutbound()
        return
      }

      // 合箱发货
      if (this.shippingType === 4) {
        await this.handleCombinedOutbound()
        return
      }

      // 原箱发货 (理论上不会执行到这里，因为原箱在扫描时已自动出库)
      if (this.shippingType === 1 || this.shippingType === 6) {
        this.$baseMessage('原箱包裹已自动出库', 'info')
        return
      }

      this.$baseMessage('未知的发货类型', 'error')
    },

    // ==================== 表格操作 ====================

    /**
     * 多选变化
     */
    handleSelectionChange(val) {
      this.selectedRows = val
    },

    /**
     * 删除行
     */
    handleDeleteRow(index) {
      // 从表格删除
      const deletedItem = this.gridData[index]
      this.gridData.splice(index, 1)

      // 如果是合箱场景，从已扫描列表中移除
      if (this.shippingType === 4 && deletedItem) {
        const idx = this.scannedPackages.indexOf(deletedItem.old_kr_code)
        if (idx > -1) {
          this.scannedPackages.splice(idx, 1)
        }
        // 如果删除后已扫描列表为空，重置合箱确认状态
        if (this.scannedPackages.length === 0) {
          this.isCombinedOrderConfirmed = false
          this.allPackageList = []
          this.combinedOrderId = ''
        }
      }

      // 如果表格为空，重置状态
      if (this.gridData.length === 0) {
        this.shippingType = null
        this.scannedPackages = []
        this.allPackageList = []
        this.combinedOrderId = ''
        this.tempCode = ''
        this.selectedRows = []
        this.isCombinedOrderConfirmed = false
      }
    },
  },
}
</script>

<style scoped lang="scss">
.dialog-footer {
  text-align: right;
  padding-top: 10px;
}

/* ==================== 弹窗圆角 ==================== */
:deep(.el-dialog) {
  border-radius: 20px;
  overflow: hidden;
}

:deep(.el-dialog__header) {
  border-radius: 20px 20px 0 0;
}

:deep(.el-dialog__footer) {
  border-radius: 0 0 20px 20px;
}

/* ==================== 扫描输入框样式 ==================== */
.scan-form-item {

  /* 标签文字大小 */
  :deep(.el-form-item__label) {
    font-size: 25px !important;
    font-weight: 500;
    line-height: 50px;
    height: 50px;
  }

  /* 输入框整体容器 */
  :deep(.el-form-item__content) {
    line-height: 50px;
  }
}

.scan-input {

  /* 输入框本身 */
  :deep(.el-input__inner) {
    font-size: 25px !important;
    height: 50px !important;
    line-height: 50px !important;
    border-radius: 12px !important;
    padding: 0 20px;
  }

  /* 输入框的清除按钮 */
  :deep(.el-input__suffix) {
    .el-input__suffix-inner {
      .el-input__clear {
        font-size: 20px;
        line-height: 50px;
      }
    }
  }

  /* 输入框的placeholder */
  :deep(.el-input__inner::placeholder) {
    font-size: 20px;
  }
}

/* ==================== 表格样式 - 字体18px ==================== */
:deep(.el-table) {
  font-size: 18px !important;

  /* 表头 */
  .el-table__header-wrapper {
    .el-table__header {
      th {
        .cell {
          font-size: 18px !important;
          font-weight: 600;
        }
      }
    }
  }

  /* 表格体 */
  .el-table__body-wrapper {
    .el-table__body {
      td {
        .cell {
          font-size: 18px !important;
        }
      }
    }
  }

  /* 空状态 */
  .el-table__empty-text {
    font-size: 18px !important;
  }
}

/* 表格内的输入框（备注列） */
:deep(.el-table) {
  .el-input__inner {
    font-size: 18px !important;
    height: 40px !important;
    border-radius: 8px !important;
  }

  .el-input__suffix {
    .el-input__suffix-inner {
      .el-input__clear {
        font-size: 16px;
        line-height: 40px;
      }
    }
  }
}

/* 表格内的开关（部分出库列） */
:deep(.el-table) {
  .el-switch {
    .el-switch__core {
      width: 44px !important;
      height: 24px !important;

      &::after {
        width: 20px !important;
        height: 20px !important;
      }
    }
  }
}

/* 表格内的按钮（操作列） */
:deep(.el-table) {
  .el-button--text {
    font-size: 18px !important;
  }
}

/* 表格多选框 */
:deep(.el-table) {
  .el-checkbox {
    .el-checkbox__inner {
      width: 18px !important;
      height: 18px !important;

      &::after {
        height: 10px !important;
        left: 5px !important;
        top: 1px !important;
        width: 5px !important;
      }
    }
  }
}

/* ==================== 包裹标签样式 ==================== */
.package-tag {
  display: inline-block;
  background: #f0f2f5;
  padding: 4px 12px;
  margin: 4px 8px 4px 0;
  border-radius: 4px;
  font-size: 13px;
  color: #333;
  transition: all 0.3s ease;

  &:last-child {
    margin-right: 0;
  }
}

/* 已扫描的包裹 - 绿色背景 */
.package-tag-scanned {
  background: #67c23a !important;
  color: #fff !important;
  position: relative;
  padding-right: 28px;
}

/* 对勾标记 */
.check-mark {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  font-weight: bold;
  font-size: 14px;
}

:deep(.el-table) {
  margin-top: 10px;
}

:deep(.el-table .cell) {
  padding: 0 8px;
}

:deep(.el-switch) {
  .el-switch__core {
    width: 40px !important;
  }
}
</style>